<div class="main-container" *ngIf="canSeeBanner">
    <div class="row content">
      <div class="el-carousel">
  
        <ngb-carousel
          #carousel
          *ngIf="banners"
          [showNavigationArrows]="false"
          [showNavigationIndicators]="false"
          [animation]="false"
          (slide)="onSlide($event)"
          (slid)="onSlid($event)"
        >
          <ng-template ngbSlide *ngFor="let banner of banners; let i = index" [id]="'banner-' + i">
            <div >
              <ng-container *ngIf="width && width > 576">
                <img [src]="banner.imageDesktop" class="img-carousel" [style.cursor]="banner.urlDestination ? 'pointer' : ''"
                  (click)="getLink(banner.urlDestination)" />
              </ng-container>
              <ng-container *ngIf="width && width <= 576">
                <img [src]="banner.imageMobile" class="img-carousel" (click)="getLink(banner.urlDestination)" />
              </ng-container>
            </div>
          </ng-template>
        </ngb-carousel>

        <button
          class="arrow-button next"
          type="button"
          *ngIf="banners?.length > 1"
          (click)="next()"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
          </svg>
        </button>

        <button
          class="arrow-button prev"
          type="button"
          *ngIf="banners?.length > 1"
          (click)="previous()"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M14 6l1.41 1.41L9.83 12l4.58 4.59L14 18l-6-6z" />
          </svg>
        </button>

        <div class="carousel-indicators custom-indicators" *ngIf="banners?.length > 1">
          <button
            type="button"
            *ngFor="let _ of banners; let i = index"
            [class.active]="i === activeIndex"
            (click)="selectBanner(i)"
            aria-label="Ir para banner"
          ></button>
        </div>
  
      </div>
    </div>
  </div>
